export default __webpack_public_path__ + "static/media/mattayom.53b08e38.png";